import { Box } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { VisibilityHandler } from './components/visibility-handler'
import { NAVIGATION_BAR_HEIGHT } from '$common/navigation-bar'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { HomePanel } from '$scenes/router-panels'

export function GeneralIssue() {
  const navigate = useNavigate()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'general-issue'

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('general-issue')
      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )

  return null
  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>
        <StaticWappPanel
          panelName="general-issue"
          wappId={StaticPanelWappId.GENERAL_ISSUE}
        />
      </Box>
    </VisibilityHandler>
  )
}
